import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/node_modules/.pnpm/@mui+material@6.1.6_@emotion+react@11.11.4_@types+react@18.2.79_react@18.2.0__@emotion+styled_rvhzhh5dzcckstng7poll7f3xu/node_modules/@mui/material/Box/Box.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/node_modules/.pnpm/@mui+material@6.1.6_@emotion+react@11.11.4_@types+react@18.2.79_react@18.2.0__@emotion+styled_rvhzhh5dzcckstng7poll7f3xu/node_modules/@mui/material/Chip/Chip.js");
;
import(/* webpackMode: "eager" */ "/workspace/node_modules/.pnpm/@mui+material@6.1.6_@emotion+react@11.11.4_@types+react@18.2.79_react@18.2.0__@emotion+styled_rvhzhh5dzcckstng7poll7f3xu/node_modules/@mui/material/Grid2/Grid2.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/node_modules/.pnpm/@mui+material@6.1.6_@emotion+react@11.11.4_@types+react@18.2.79_react@18.2.0__@emotion+styled_rvhzhh5dzcckstng7poll7f3xu/node_modules/@mui/material/Stack/Stack.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/node_modules/.pnpm/@mui+material@6.1.6_@emotion+react@11.11.4_@types+react@18.2.79_react@18.2.0__@emotion+styled_rvhzhh5dzcckstng7poll7f3xu/node_modules/@mui/material/Typography/Typography.js");
;
import(/* webpackMode: "eager" */ "/workspace/node_modules/.pnpm/next@15.3.1_@babel+core@7.24.4_@opentelemetry+api@1.6.0_babel-plugin-macros@3.1.0_react-dom@1_vkdhzdrzp3q2adjsa4vieti4ca/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/workspace/packages/landing/dist/assets/images/solar-support/business-img-1-1.png");
;
import(/* webpackMode: "eager" */ "/workspace/packages/landing/dist/assets/images/solar-support/business-img-1-2.png");
;
import(/* webpackMode: "eager" */ "/workspace/packages/landing/dist/assets/images/solar-support/business-img-1-3.png");
;
import(/* webpackMode: "eager" */ "/workspace/packages/landing/dist/assets/images/solar-support/business-img-1-4.png");
;
import(/* webpackMode: "eager" */ "/workspace/packages/landing/dist/assets/images/solar-support/business-img-2-1.png");
;
import(/* webpackMode: "eager" */ "/workspace/packages/landing/dist/assets/images/solar-support/business-img-2-2.png");
;
import(/* webpackMode: "eager" */ "/workspace/packages/landing/dist/assets/images/solar-support/business-img-3-1.png");
;
import(/* webpackMode: "eager" */ "/workspace/packages/landing/dist/assets/images/solar-support/business-img-3-2.png");
;
import(/* webpackMode: "eager" */ "/workspace/packages/landing/dist/assets/images/solar-support/business-img-4.png");
;
import(/* webpackMode: "eager" */ "/workspace/packages/landing/dist/assets/images/solar-support/business-img-m-1-1.png");
;
import(/* webpackMode: "eager" */ "/workspace/packages/landing/dist/assets/images/solar-support/business-img-m-1-2.png");
;
import(/* webpackMode: "eager" */ "/workspace/packages/landing/dist/assets/images/solar-support/business-img-m-1-3.png");
;
import(/* webpackMode: "eager" */ "/workspace/packages/landing/dist/assets/images/solar-support/business-img-m-1-4.png");
;
import(/* webpackMode: "eager" */ "/workspace/packages/landing/dist/assets/images/solar-support/business-img-m-2-1.png");
;
import(/* webpackMode: "eager" */ "/workspace/packages/landing/dist/assets/images/solar-support/business-img-m-2-2.png");
;
import(/* webpackMode: "eager" */ "/workspace/packages/landing/dist/assets/images/solar-support/business-img-m-3-1.png");
;
import(/* webpackMode: "eager" */ "/workspace/packages/landing/dist/assets/images/solar-support/business-img-m-3-2.png");
;
import(/* webpackMode: "eager" */ "/workspace/packages/landing/dist/assets/images/solar-support/business-img-m-4.png");
